import useColor from "@/utils/hooks/useColor";
import { getInitials } from "@/utils/utility";
import Valkyrie from "@sippy-platform/valkyrie";

import MuiAvatar from "@mui/material/Avatar";
import { blue } from "@mui/material/colors";
import PropTypes from "prop-types";

function Avatar({ icon = undefined, text = "", px = 32, color, main = false, literal, ...props }) {
  const content = literal ? text : icon ? <Valkyrie icon={icon} /> : getInitials(text?.toString());
  const { color: textColor, background } = useColor(text, !text && !color ? blue[500] : color);

  return (
    <MuiAvatar
      {...props}
      aria-label={text}
      sx={[
        {
          width: px,
          height: px,
          fontSize: px / 2,
          fontWeight: 600,
          lineHeight: `${px}px`,
        },
        !main && {
          color: `${textColor} !important`,
          background: `linear-gradient(135deg, ${background[300]} 0%, ${background[400]} 100%)`,
        },
      ]}
    >
      {content || " "}
    </MuiAvatar>
  );
}

Avatar.propTypes = {
  px: PropTypes.number,
  icon: PropTypes.object,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.string,
  main: PropTypes.bool,
  literal: PropTypes.bool,
};

export default Avatar;
